import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { CustomerProfilesPermissions } from './customer-management.customer-profiles.permissions';
import { getCustomerManagementModuleName } from './customer-management.permissions';

export class CustomerProfileEligibleAccountsPermissions {
  static GroupName = `${getCustomerManagementModuleName()}.EligibleAccounts`;

  static getPermissions = getGroupPermissionFactory(
    CustomerProfileEligibleAccountsPermissions.GroupName,
  );

  static Permissions = {
    Read: CustomerProfileEligibleAccountsPermissions.getPermissions(
      PermissionEnum.READ,
    ),
  };
}
